<template>
    <div>
        <div class="box">
            <div class="head">
                <div class="centered-content">
                    <img :src="logo"  class="logo">
                </div>
            </div>
            <div class="box2" style="padding-top: 13vw;">
            <div class="box_input">
                <div class="box_text">
                    <span class="box_text_s">欢迎注册</span>
                </div>
                <div class="box_list">
                    <img src="../../assets/images/icon_building.png" style="margin-left: 10px;">
                    <input type="text" name="" v-model="dat.name" class="form-control" id="" placeholder="输入企业/商户简称">
                </div>
                <div class="box_list">
                    <img src="../../assets/images/icon_moblie.png" style="margin-left: 10px;">
                    <input type="text" name="" v-model="dat.phone" class="form-control" id="" placeholder="输入手机号">
                </div>
                <div class="box_list">
                        <input v-model="dat.code" type="text" placeholder="请输入短信验证码" class="form-control2">
                        <van-button :disabled="countdown > 0" size="normal" type="primary" class="rounded-button"
                                @click="startCountDown">
                                {{ countdown > 0 ? `${countdown} 秒后重新获取` : '获取验证码' }}
                            </van-button>
                    </div>
                <div class="box_list" v-if="invites">
                    <input type="text" name="" v-model="dat.Inviter" class="form-control" id="" placeholder="输入邀请码（可选）">
                </div>
            </div>
            <div class="btn_box">
                <div>
                <input type="button" class="btn" value="注册" @click="getClasd()">
                </div>
                <div>
                    <img src="../../assets/images/Buttons_Button_Type_Outlined__Status_Enabled@2x.png" alt=""  @click="Download" class="btn_img">
                </div>
            </div>
                
        </div>
        <div class="half-rounded-div">
                    <span class="half-font">下滑进一步了解</span>
                    <div class="half-img">
                        <img src="../../assets/images/Component_1_Property_1_Default@2x.png" alt="" width="12px" height="20px">
                    </div>
                </div>
        </div>
        <div style="height: 463px; width: 100%;">
            <img src="../../assets/images/Frame_399.png" width="375px" height="463px">
        </div>
        <div>
            <div class="scrollable-container">
                <div class="scrollable-content">
                    <img src="../../assets/images/Frame_383@2x.png" width="210px" height="424px">
                    <img src="../../assets/images/Frame_383@2x.png" width="210px" height="424px">
                    <img src="../../assets/images/Frame_383@2x.png" width="210px" height="424px">
                </div>
            </div>
        </div>
        <div class="Software">
            <span class="Software-text">软件界面图</span>
        </div>
        <div>
            <img src="../../assets/images/section-04@2x.png" width="375px" height="597px">
        </div>
        <!-- <div class="Company">
            <div class="Company2">
                <div class="company3">
                    <span class="company2-font">
                        公司介绍
                    </span>
                </div>
                <div class="company4">
                    <div v-html="description"></div>
                </div>
            </div>
        </div>
        <div class="broker">
            <div class="broker2">
                <div class="broker3">
                    <span class="broker3-font">
                        代理招募
                    </span>
                </div>
                <div class="broker4-container">
                    <div class="broker4">
                        <div class="borker4_img">
                            <img src="../../assets/images/icon_link@2x.png" style="margin-left: 10px;" width="20px" height="21px">
                        </div>
                        <div class="ceshi">
                            <span class="broker4-font">
                            {{ link }}
                        </span>
                        </div>
                        
                    </div>
                    <div class="broker4">
                        <div class="borker4_img">
                        <img src="../../assets/images/icon_phone_number@2x.png" style="margin-left: 10px;" width="20px" height="21px">
                        </div>
                        <div class="ceshi">
                        <span class="broker4-font">
                            {{ contact }}
                        </span>
                    </div>
                    </div>
                    <div class="broker4">
                        <div class="borker4_img">
                        <img src="../../assets/images/icon_address@2x.png" style="margin-left: 10px;" width="20px" height="21px">
                        </div>
                        <div class="ceshi">
                        <span class="broker4-font">
                            {{ address }}
                        </span>
                    </div>
                    </div>
                </div>
                <div>
                    <img :src="qrcode" class="qrcode">
                </div>
            </div>
        </div> -->
        <div class="Record">
            <div class="Record1">
                <span style="text-align: center;" class="Record1-font">
                    {{ serialno }}
                </span>
                
            </div>
            <div>
                <div v-html="coryright"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'; // 导入 axios 库
    import {LoginAs,Register} from '../../network/login'
    export default {
        name: '',
        data() {
            return {
                dat: {
                    name: '',
                    phone: '',
                    code:'',
                    Inviter:''
                },
                countdown: 0, // 初始化倒计时为0
                address: undefined,
                contact: undefined,
                coryright: undefined,
                description: undefined,
                link: undefined,
                logo: undefined,
                qrcode: undefined,
                serialno: undefined,
                invites:true


            };
        },
        created() {
            console.log(this.$route.query.p);
            if(this.$route.query.p!=undefined){
                this.dat.Inviter=this.$route.query.p
                this.invites=false
            }

            axios.get('https://api.zhibo.yunji.world/web/home').then(res => {
                console.log(res);
                document.title = res.data.result.title;
                this.address = res.data.result.address;
                this.contact = res.data.result.contact;
                this.coryright = res.data.result.coryright;
                this.description = res.data.result.description;
                this.link = res.data.result.link;
                this.logo = res.data.result.logo;
                this.qrcode = res.data.result.qrcode;
                this.serialno = res.data.result.serialNo;

            }).catch(error => {
                console.log(error);
            })
        },
        methods: {
            Download(){
                this.$router.push('/download')
            },
            startCountDown() {
                if (!this.dat.phone) {
                    this.$toast.fail("请输入手机号");
                    return;
                }
                LoginAs({ phone:this.dat.phone}).then(res=>{
                    console.log(res);
                    if(res.data.responseCode===100){
                        this.$toast.success("发送验证码成功");
                    }else {
                        this.$toast.success(res.data.responseText);
                    }
                })
                // 如果倒计时未开始
                if (this.countdown === 0) {
                    // 启动倒计时，这里设置为60秒，你可以根据需要调整
                    this.countdown = 60;

                    // 开始倒计时
                    const timer = setInterval(() => {
                        if (this.countdown > 0) {
                            this.countdown--;
                            

                        } else {
                            // 倒计时结束，清除定时器
                            clearInterval(timer);
                        }
                    }, 1000);
                }
            },
            getClasd() {
                
                if (!this.dat.name) {
                    this.$toast.fail("请输入公司名称");
                    return;
                }
                if (!this.dat.code) {
                    this.$toast.fail("请输入验证码");
                    return;
                }
                if (!this.dat.phone) {
                    this.$toast.fail("请输入手机号");
                    return;
                }
                Register(this.dat).then(res=>{
                    console.log(res);
                    if(res.data.responseCode===100){
                        this.$toast.success("注册成功");
                        this.$router.push('/download')
                        
                    }else {
                        this.$toast.success(res.data.responseText);
                    }
                })
                   
                

            }
        }

    }
</script>
<style>
    

    

    input::placeholder {
        color: #0000003d;
        font-family: 'OPlusSans 3.0', sans-serif;
        font-weight: 500;
        font-size: 4vw;
    }
</style>
<style lang='less' scoped>
    @import 'vant/lib/index.css';
    @import '../../assets/style/register.less';
</style>